import { applicationData } from "./application"

const mockApi = {
  applicationData
}

export default mockApi
